import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

/**
 * Datum uit de REST API (ISO 8601) naar dd/mm/jjjj of mm/dd/jjjj. Verving
 * moment.js, dat hier alleen voor deze twee formatteringen werd geladen en
 * ruim 300 kB aan de bundel toevoegde.
 */
const formatDate = (raw, amerikaans = false) => {
  const d = new Date(raw)
  if (isNaN(d.getTime())) return ''

  const dag = String(d.getDate()).padStart(2, '0')
  const maand = String(d.getMonth() + 1).padStart(2, '0')
  const jaar = d.getFullYear()

  return amerikaans ? `${maand}/${dag}/${jaar}` : `${dag}/${maand}/${jaar}`
}

// Card widths from .c-projects__col in main.scss; equal to ProjectsOverview::IMAGE_SIZES
const IMAGE_SIZES = '(min-width: 80em) 33vw, (min-width: 40em) 50vw, calc(100vw - 2rem)'

// views/shared/project-card.twig renders this same markup server-side for hydrate; keep both equal.
const Project = props => {
  let project = props.project
  let title = project.title.rendered
  let markets = project.market_names.join(', ')
  let link = project.detail_url
  let hasDetail = project.has_detail_page
  let excerpt = project.excerpt.rendered
  let raw_date = project.date
  let date = formatDate(raw_date)
  let feat_image = project.feat_image

  let text_show = 'Bekijk project'

  if (props.language == 'en') {
    text_show = 'View project'
    date = formatDate(raw_date, true)
  }

  let Tag = hasDetail ? 'a' : 'div'
  let wrapProps = { className: 'c-project c-projects__col' }
  if (hasDetail) {
    wrapProps.href = link
  }

  return (
    <Tag {...wrapProps}>
      <div className="c-project__image u-image">
        {feat_image && (props.eager || props.imagesReady) && (
          <img src={feat_image} srcset={project.feat_image_srcset || undefined} sizes={project.feat_image_srcset ? IMAGE_SIZES : undefined} alt={title} className="c-project__background u-image__background" loading={props.eager ? 'eager' : 'lazy'} fetchpriority={props.eager ? 'high' : 'auto'} />
        )}
      </div>

      <div className="c-project__header u-flex u-flex-sb">
        <div className="c-project__markets" dangerouslySetInnerHTML={{ __html: markets }} />

        <div className="c-project__date">{date}</div>
      </div>

      <div className="c-project__body">
        <h3 className="c-project__title" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="c-project__excerpt" dangerouslySetInnerHTML={{ __html: excerpt }} />
      </div>

      {hasDetail && (
        <div className="c-project__footer">
          <span className="c-project__button">{text_show}</span>
        </div>
      )}
    </Tag>
  )
}

export default Project



// WEBPACK FOOTER //
// ./src/js/projects/components/Project.js